import React, { useState, useEffect } from "react";
import { Button, Form, Input, Radio } from "antd";
import { framework_tool, component_tool } from '@/tool'
let { WizFileUpload } = framework_tool;
import { connect } from 'dva';
let { WizTable, WizModal, Wizmessage } = component_tool;
import ScheduleList from "./listSelect/scheduleList";
import StageList from "./listSelect/stageList";

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

const Way = ({ form, data, submit, cancel, resetNum, ...props }) => {
  const [pathList, setPathList] = useState([])
  const [editIndex, setEditIndex] = useState()
  const [wayList, setWayList] = useState([])
  const [locPathId, setLocPathId] = useState()
  const [rowDate, setRowDate] = useState(new Date().getTime())
  const [rowDateB, setRowDateB] = useState(new Date().getTime())
  const [selectedScheduleRows, setSelectedScheduleRows] = useState([])
  const [selectedStageRows, setSelectedStageRows] = useState([])
  const [stageListVisible, setStageListVisible] = useState(false)
  const [wayListVisible, setWayListVisible] = useState(false)
  const { getFieldDecorator, validateFields, setFields, resetFields, setFieldsValue, getFieldsValue } = form

  useEffect(() => {
    console.log(data?.trainPathStageList, 'data?.trainPathStageList?')
    if (data?.trainPathStageList?.length > 0) {
      let convertList = data.trainPathStageList.map(x => {
        return {
          trainPathId: x.pathId, trainPathName: x.pathName, id: x.stageId, name: x.stageName
        }
      })
      setWayList(convertList)
    }
  }, [data])
  useEffect(() => {
    setFieldsValue({ state: data.state || 0 })
    if (data?.trainPathStageList?.length > 0) {
      let convertList = data.trainPathStageList.map(x => {
        return {
          trainPathId: x.pathId, trainPathName: x.pathName, id: x.stageId, name: x.stageName
        }
      })
      setWayList(convertList)
    }
  }, [resetNum])
  const _submit = (pass) => {

    validateFields((err, values) => {
      if (!err) {
        if (values.state == 0 || (values.state == 1 && wayList?.length > 0)) {
          values.trainPathStageList = wayList.map(x => { return { stageId: x.id } })
          console.log(values, 'valuesvaluesvaluesvalues')
          if (pass === 3) {
            submit && submit({ ...values }, 3, 'way');
            // resetFields()
            return;
          } else {
            submit && submit({ ...values }, 2, 'way');
            // resetFields()
          }
          Wizmessage.success('保存成功')
        } else {
          Wizmessage.warning('请选择路径')
        }
      }
    });
  }
  formatLink = ({ fileType, fileId, address }) => {
    let newFileId = getOssFilePath(fileId[0]?.fileId || '')
    let fileOriginalName = fileId[0]?.fileOriginalName || ''
    if (fileType == 0) {
      return <a href={newFileId}>
        {fileOriginalName}
      </a>
    } else {
      return address
    }
  }
  const columns = [
    {
      title: '路径名称',
      dataIndex: 'trainPathName',
      key: 'trainPathName',
      width: 60
    },
    {
      title: '阶段',
      dataIndex: 'name',
      key: 'name',
      width: 120,
      ellipsis: true,
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      width: 160,
      render: (text, record, index) => (
        <span>
          <a onClick={e => editRecord(record, index)}> 编辑</a>
          <a onClick={e => deleteRow(record)}> 删除</a>
        </span>
      ),
    },
  ];
  resetContent = () => {
    console.log('resetContentresetContentresetContent')
  }
  editRecord = (record, index) => {
    let row = pathList.find(x => x.id == record.trainPathId)
    setSelectedScheduleRows([row])
    setSelectedStageRows([record])
    setEditIndex(index)
    setWayListVisible(true)

  }
  deleteRow = (record) => {
    let list = [...wayList]
    list = list.filter(x => x.id != record.id)
    setWayList(list)
  }
  pushProgramContent = () => {
    console.log(selectedScheduleRows, 'selectedScheduleRows')
    if (selectedScheduleRows[0]?.id) {
      setWayListVisible(false)
      setStageListVisible(true)
    }
  }
  pushStageContent = () => {
    let list = [...wayList]
    let listB = [...pathList]
    let stageList = [...selectedStageRows]
    let trainList = [...selectedScheduleRows]
    if (editIndex || editIndex == 0) {
      list[editIndex] = stageList[0]
      trainList[editIndex] = trainList[0]
    } else if (stageList[0]?.id && trainList[0]?.id) {
      if (list.findIndex(x => x.id == stageList[0].id) > -1) {
        list[list.findIndex(x => x.id == stageList[0].id)] = stageList[0]
        trainList[list.findIndex(x => x.id == stageList[0].id)] = trainList[0]
      } else {
        list = list.concat(stageList)
        listB = listB.concat(trainList)
      }
    }
    setPathList(listB)
    setWayList(list)
    console.log(list, 'list777777')
    let arr = []
    list.forEach(item => {
      arr.push({ stageId: item.id })
    })
    setFieldsValue({ trainPathStageList: arr })
    setStageListVisible(false)
  }
  selectRows = (rows, key, name) => {
    /**将选择的数据添加至state中 */
    let list = [];
    rows && rows.forEach(row => {
      //row.userName = row[name];
      list.push(row);
    });
    if (key == 'selectedStageRows') {
      setSelectedStageRows(list)
      setRowDate(new Date().getTime())
    } else {
      setSelectedScheduleRows(list)
      setRowDateB(new Date().getTime())
    }
  }
  openPathList = () => {
    setEditIndex()
    setSelectedScheduleRows([])
    setSelectedStageRows([])
    setWayListVisible(true)
  }
  const { state = 0, trainPathStageList } = data || {}
  // let initTrainPathStageList = trainPathStageList.map(x => { return {
  //    trainPathId: x.pathId, trainPathName: x.pathName, id: x.stageId, name: x.stageName } })
  return (
    <Form {...formItemLayout}>
      <Form.Item label="添加到路径">
        {getFieldDecorator('state', {
          initialValue: state,
        })(<Radio.Group
        // onChange={(e) => {
        // console.log(e, 'value777')
        //   setType(e.target.value)
        // }} value={state}
        >
          <Radio value={1}>是</Radio>
          <Radio value={0}>否</Radio>
        </Radio.Group>)
        }
      </Form.Item>
      {getFieldsValue().state == 1 ? <Form.Item wrapperCol={{ span: formItemLayout?.wrapperCol?.span, offset: formItemLayout?.labelCol?.span }}>
        {getFieldDecorator('trainPathStageList', {
          // initialValue: initTrainPathStageList,
        })(
          <>
            <Button onClick={() => openPathList()}>选择路径</Button>
            <div className="table-row" key={'program_content_'}>
              <WizTable pagination={false} columns={columns} dataSource={wayList} />
            </div>
            <WizModal
              visible={wayListVisible}
              onCancel={() => setWayListVisible(false)}
              onOk={() => pushProgramContent('schedule')}
              style={{ minWidth: 1000 }}
              title={'选择路径'}
            // key={this.state.scheduleListModalKey}
            >
              <ScheduleList exists={wayList}
                // handleClear={id => this.handleClear(id, 'selectedScheduleRows')}
                selectedRows={selectedScheduleRows}
                updateRows={(rows) => selectRows(rows, 'selectedScheduleRows', 'name')}
              />
            </WizModal>
            <WizModal
              visible={stageListVisible}
              onCancel={() => setStageListVisible(false)}
              onOk={() => pushStageContent('schedule')}
              style={{ minWidth: 1000 }}
              title={'选择路径'}
              destroyOnClose={true}
            // key={this.state.scheduleListModalKey}
            >
              <StageList // handleClear={id => this.handleClear(id, 'selectedScheduleRows')}
                existId={selectedScheduleRows[0]?.id}
                selectedRows={selectedStageRows}
                updateRows={(rows) => selectRows(rows, 'selectedStageRows', 'name')}
              />
            </WizModal>
          </>
        )
        }
      </Form.Item> : null}
      <Form.Item wrapperCol={{ span: formItemLayout?.wrapperCol?.span, offset: formItemLayout?.labelCol?.span }}>
        <Button type='primary' onClick={() => _submit(2)}>保存</Button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <Button onClick={() => _submit(3)}>保存并关闭</Button>
      </Form.Item>
    </Form >
  )
}
// let WayForm =Form.create()(connect(null, null, null, { withRef: true })(Way));
let WayForm = Form.create()(Way)
export {
  WayForm,
}


